import React, { useState, useEffect } from "react";
import { searchQ } from "../axios";
import ProductOne from "../components/product/productOne";
import { Link, useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import ProductCard from "../components/product/ProductCard/ProductCard";

const ShopResult = () => {
  const [products, setProducts] = useState([]);

  const { id } = useParams();

  useEffect(() => {
    searchQ(id).then(({ data }) => {
      const mainProducts = data?.filter(item => item.isAsli === true && item.categoryID !== 4 && item.isSite === true)
      const uniqueFlashCarts = Array.from(
        new Map(data.filter(item => item.categoryID == 4).reverse().map(item => [item.title, item])).values()
    );
      setProducts([...mainProducts, ...uniqueFlashCarts]);
    });
  }, [id]);

  const { pathname } = useLocation();

  // Automatically scrolls to top whenever pathname changes
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [pathname]);

  return (
    <React.Fragment>
      <div className="breadcrumbs_area">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="breadcrumb_content">
                <ul>
                  <li>
                    <Link to="/">خانه</Link>
                  </li>

                  <li>جستجو</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="shop_area shop_reverse mt-60 mb-60">
        <div className="container">
          <div className="row">
            {/* <div className="col-lg-3 col-md-12">
              <aside className="sidebar_widget">
                <div className="widget_inner">
                  <div className="widget_list widget_categories">
                    <h2>دسته های محصولات</h2>

                    <ul>
                      {categorySet.map((item) => (
                        <li onClick={callNewProducts}>
                          <Link to={`/shop/${item.id}`}>
                            {item.categoryTitle}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
               
                
                </div>
              </aside>
            </div> */}
            <div className="col-lg-12 col-md-12">
              <div className="row shop_wrapper">
                {products.map((item, index) => (
                  <div key={index} className="col-lg-3 col-md-3 col-sm-6">
                    {item.categoryID == 4 ? (
                      <article className="single_product ">
                      <div className="single_product_wrapper">
                          
                      </div>
                
                      <figure className="product-one-card">
                        {/* ----------------------------------------- Product Image --------------------------------------- */}
                
                        <ProductCard
                          discount={""}
                          item={item}
                          hover={""} 
                          link={`/shop?catId=4&subCatId=${item.subCategoryID}`}
                          commingSoon={item.isCommingSoon}
                        />
                
                        {/* ----------------------------------------- End Product Image --------------------------------------- */}
                
                        <figcaption className="product_content" style={item.isCommingSoon ? { minHeight: "50px" } : { minHeight: "150px" }}>
                          {/* ------------------------------ title --------------------------- */}
                          <p
                            className="product_name"
                            style={{
                              fontSize: "16px",
                              fontWeight: "500",
                            }}
                          >
                            {item.isCommingSoon ? (
                              <h3 className="price" style={{ color: "blue" }}>
                                {item.title}
                              </h3>
                            ) : (
                              <Link to={`/product/${item.id}`} className="text-info">
                                {item.title}
                              </Link>
                            )}
                          </p>
                          
                          {/* ------------------------------ button  --------------------------- */}
                
                          {!item.isCommingSoon ? (
                            <div className="add_to_cart">
                              <Link
                              to={`/shop?catId=4&subCatId=${item.subCategoryID}`}
                                style={{ color: "white" }}
                                // onClick={(e) => e.preventDefault()}
                                className="btn btn-sm w-75 mt-auto  mx-auto"
                              >
                                نمایش محصول
                              </Link>
                            </div>
                          ) : null}
                        </figcaption>
                      </figure>
                    </article>
                    ) : (<ProductOne
                      item={item}
                      hover={
                        item.type === "audio" || item.type === "video"
                          ? false
                          : true
                      }
                    />)}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ShopResult;
